import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.5rem'
  },

  input: {
    outline: 'none',
    border: '1px solid #E5EAF1',
    borderRadius: '5px',
    boxSizing: 'border-box',
    height: '36px',
    padding: '0 0 0 16px',
    fontSize: theme.size.sm,
    color: '#1F1F1F',
    background: 'white',

    '&::placeholder': {
      color: '#888888 !important'
    },

    '&:focus': {
      borderColor: theme.palette.primary.main
    }
  },

  noResults: {
    textAlign: 'center',
    fontSize: theme.size.sm,
    color: '#888888'
  },

  results: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.25rem',
    maxHeight: '30svh',
    overflowY: 'auto'
  }
}))

export default useStyles
